import React from 'react'
import cn from 'classnames'

import { Link } from 'react-router-dom'
import { percentageFormat, priceColor } from '../../core/helpers'

import LoaderValue from '../Loader/LoaderValue'
import ChartLight from '../Chart/ChartLight'

function OverviewValueChange({ title, value, change, points, seeMoreLink }) {
  return (
    <Link to={seeMoreLink} className="no-underline">
      <div className="rounded-xl border-0" style={{ backgroundColor: '#13151a' }}>
        <div className="p-3 pb-1 border-0 rounded-xl text-grey">
          {title}
        </div>
        <div className="px-3 pb-3 pt-0">
          <div className="grid grid-cols-2">
            <div>
              <div className="md:font-semibold sm:font-medium text-oz uppercase whitespace-nowrap">
                {value ? value : <LoaderValue width="100" height="11" />}
              </div>
              <div className={cn('whitespace-nowrap', priceColor(change))}>
                {change ? percentageFormat(change) : <LoaderValue width="60" height="11" />}
              </div>
            </div>
            <div>
              {points && <ChartLight
                className="flex h-full items-end justify-end"
                points={points}
                change={change}
              />}
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default OverviewValueChange
